<template>
    <div class="component-settings-store-detail">
        <div class="row">
            <div class="col-12" :style="$store.state.general.settingsMenuMode === 'vertical' ? {'padding': '0px'} : {}">
                <div class="el-card__header text-left border-settings-header" slot="header">
                    <div class="row center-align-vert">
                        <div class="col-6 center-align-vert">
                            <el-button @click="$router.push({ 'name': 'settings-stores'})"  class="inline fl mr-10" icon="el-icon-back"></el-button>
                            <h4 class="inline">Store {{$route.query.store_id}}</h4>
                        </div>
                        <div class="col-6 fr">
                            <el-button class="fr" type="primary" @click="submit" @submit.prevent="submit">Save</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-card class="box-card" id="main-header" shadow="never"
                 style="border: none; border-radius: 0px; min-height: 400px; background-color: #f4f7fa;"
                 body-style="background-color: #f4f7fa; padding: 20px 0px;"
        >
            <div class="row">
                <div class="col-12">
                    <h5 class="title-left-bold mt-50">Store details</h5>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card text-left" shadow="never"  v-if="loaded">
                        <div class="row">
                            <div class="col-12">
                                <el-form ref="formSettings" :rules="rules" :model="form" label-width="120px">
                                    <!-- Hardcoded (always there) store properties -->
                                    <el-form-item prop="store_id" label="Store ID">
                                        <el-input disabled v-model="form.store_id"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="store_name" label="Name">
                                        <el-input v-model="form.store_name"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Active" class="text-left">
                                        <el-switch v-model="form.active"></el-switch>
                                    </el-form-item>
                                    <el-form-item label="Surface" prop="store_square_meters">
                                        <el-input v-model="form.store_square_meters"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Min. employees" prop="min_employees">
                                        <el-input @change="calcMinimum('all')" v-model="form.min_employees"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Sunday opening">
                                        <el-select v-model="form.opening_sunday" placeholder="Select">
                                            <el-option
                                                v-for="item in sundayOpeningOptions"
                                                :key="item"
                                                :label="item | formatVariableName"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>

                                    <!-- {{form.dataload}}
                                    {{parameterOptions}} -->

                                    <!-- Loop through dataload -->
                                    <el-form-item :prop="'dataload.'+key" v-for="(value,key) in form.dataload" :key="key" :label="key | formatVariableName">
                                        <el-input v-if="parameterOptions.find(x => x.name === key).type !== 'boolean'" v-model="form.dataload[key]" style="display: inline-block; width: 80%;"></el-input>
                                        <el-switch class="inline" style="width: 80%;" v-if="parameterOptions.find(x => x.name === key).type === 'boolean'" v-model="form.dataload[key]"></el-switch>
                                        <el-button size="medium" icon="el-icon-delete" type="danger" @click="deleteExistingProperty(key)" class="fr mr-10 inline-block"></el-button>
                                    </el-form-item>

                                    <!-- If there are parameters left that are not denifed, let user add these -->
                                    <div v-if="parametersLeft + this.parameters.length > 0">
                                        <div class="row mb-10">
                                            <div class="col-12">
                                                <p class="inline" style="font-weight: 800; line-height: 36px;">Add more store information</p>
                                                <el-button v-show="parametersLeft > 1" size="medium" icon="el-icon-plus" type="primary" :disabled="numParams > 0 && parameters[numParams-1] === undefined" @click="numParams +=1" class="fr inline-block"></el-button>
                                            </div>
                                        </div>
                                        <transition-group name="fade" mode="out-in">
                                            <el-form-item :prop="+parameters[idx] === undefined ? '' : 'dataload.'+parameters[idx]" :label="parameters[idx] === undefined ? 'New parameter' : parameters[idx] | formatVariableName" v-for="(prop,idx) in numParams" :key="prop">
                                                <el-select style="width: 250px" v-if="parameters[idx] === undefined" v-model="parameters[idx]" placeholder="Select a parameter">
                                                    <el-option
                                                        :disabled="Object.keys(form).includes(item.name) || Object.keys(form.dataload).includes(item.name) || parameters.includes(item.name)"
                                                        v-for="item in parameterOptions"
                                                        :key="item.name"
                                                        :label="item.name | formatVariableName"
                                                        :value="item.name">
                                                    </el-option>
                                                </el-select>
                                                <div v-if="parameters[idx] !== undefined && parameterOptions.find(x => x.name === parameters[idx]).type !== 'boolean'">
                                                    <el-input class="inline" style="width: 80%;" v-show="parameters[idx] !== undefined" v-model="parameterValues[idx]"></el-input>
                                                    <el-button v-show="parameters[idx] !== undefined" size="medium" icon="el-icon-delete" type="danger" @click="deleteNewProperty(parameters[idx])" class="inline-block fr mr-10"></el-button>
                                                </div>
                                                <div v-if="parameters[idx] !== undefined && parameterOptions.find(x => x.name === parameters[idx]).type === 'boolean'">
                                                    <el-switch class="inline" style="width: 80%;" v-model="parameterValues[idx]"></el-switch>
                                                    <el-button v-show="parameters[idx] !== undefined" size="medium" icon="el-icon-delete" type="danger" @click="deleteNewProperty(parameters[idx])" class="inline-block fr mr-10"></el-button>
                                                </div>
                                            </el-form-item>
                                        </transition-group>
                                    </div>
                                </el-form>
                            </div>
                        </div>
                    </el-card>
                    <h5 class="title-left-bold mt-50">Store times</h5>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card text-left" shadow="never"  v-if="loaded">
                        <el-form ref="formHours" :model="form" label-width="120px">
                            <el-form-item label="Monday" prop="opening_times.monday.open">
                                <span class="form-label-times">Open</span>
                                <el-time-select
                                    v-model="form.opening_times.monday.open"
                                    placeholder="Open"
                                    @change="calcMinimum('monday')"
                                    :picker-options="{
                                        start: '00:00',
                                        step: '00:30',
                                        end: '23:30'
                                    }">
                                </el-time-select>
                                <span class="form-label-min-hours">Close</span>
                                <el-time-select
                                    arrow-control
                                    v-model="form.opening_times.monday.close"
                                    placeholder="Close"
                                    @change="calcMinimum('monday')"
                                    class="ml-5-howrly"
                                    :picker-options="{start: '00:00', step: '00:30', end: '23:30' }">
                                </el-time-select>
                                <span class="form-label-min-hours">Minimum</span>
                                <el-input :disabled=true class="min-hours-field" v-model="form.min_hours.monday"></el-input>
                            </el-form-item>
                            <el-form-item label="Tuesday">
                                <span class="form-label-times">Open</span>
                                <el-time-select
                                    v-model="form.opening_times.tuesday.open"
                                    @change="calcMinimum('tuesday')"
                                    placeholder="Open">
                                </el-time-select>
                                <span class="form-label-min-hours">Close</span>
                                <el-time-select
                                    arrow-control
                                    v-model="form.opening_times.tuesday.close"
                                    @change="calcMinimum('tuesday')"
                                    placeholder="Close"
                                    class="ml-5-howrly"
                                    :picker-options="{start: '00:00', step: '00:30', end: '23:30' }">
                                </el-time-select>
                                <span class="form-label-min-hours">Minimum</span>
                                <el-input :disabled=true class="min-hours-field" v-model="form.min_hours.tuesday"></el-input>
                            </el-form-item>
                            <el-form-item label="Wednesday">
                                <span class="form-label-times">Open</span>
                                <el-time-select
                                    v-model="form.opening_times.wednesday.open"
                                    @change="calcMinimum('wednesday')"
                                    placeholder="Open">
                                </el-time-select>
                                <span class="form-label-min-hours">Close</span>
                                <el-time-select
                                    arrow-control
                                    v-model="form.opening_times.wednesday.close"
                                    placeholder="Close"
                                    @change="calcMinimum('wednesday')"
                                    class="ml-5-howrly"
                                    :picker-options="{start: '00:00', step: '00:30', end: '23:30' }">
                                </el-time-select>
                                <span class="form-label-min-hours">Minimum</span>
                                <el-input :disabled=true class="min-hours-field" v-model="form.min_hours.wednesday"></el-input>
                            </el-form-item>
                            <el-form-item label="Thursday">
                                <span class="form-label-times">Open</span>
                                <el-time-select
                                    v-model="form.opening_times.thursday.open"
                                    @change="calcMinimum('thursday')"
                                    placeholder="Open">
                                </el-time-select>
                                <span class="form-label-min-hours">Close</span>
                                <el-time-select
                                    arrow-control
                                    @change="calcMinimum('thursday')"
                                    v-model="form.opening_times.thursday.close"
                                    placeholder="Close"
                                    class="ml-5-howrly"
                                    :picker-options="{start: '00:00', step: '00:30', end: '23:30' }">
                                </el-time-select>
                                <span class="form-label-min-hours">Minimum</span>
                                <el-input :disabled=true class="min-hours-field" v-model="form.min_hours.thursday"></el-input>
                            </el-form-item>
                            <el-form-item label="Friday">
                                <span class="form-label-times">Open</span>
                                <el-time-select
                                    @change="calcMinimum('friday')"
                                    v-model="form.opening_times.friday.open"
                                    placeholder="Open">
                                </el-time-select>
                                <span class="form-label-min-hours">Close</span>
                                <el-time-select
                                    arrow-control
                                    @change="calcMinimum('friday')"
                                    v-model="form.opening_times.friday.close"
                                    placeholder="Close"
                                    class="ml-5-howrly"
                                    :picker-options="{start: '00:00', step: '00:30', end: '23:30' }">
                                </el-time-select>
                                <span class="form-label-min-hours">Minimum</span>
                                <el-input :disabled=true class="min-hours-field" v-model="form.min_hours.friday"></el-input>
                            </el-form-item>
                            <el-form-item label="Saturday">
                                <span class="form-label-times">Open</span>
                                <el-time-select
                                    v-model="form.opening_times.saturday.open"
                                    placeholder="Open"
                                    @change="calcMinimum('saturday')"
                                    class="time-select-input">
                                </el-time-select>
                                <span class="form-label-min-hours">Close</span>
                                <el-time-select
                                    arrow-control
                                    @change="calcMinimum('saturday')"
                                    v-model="form.opening_times.saturday.close"
                                    placeholder="Close"
                                    class="ml-5-howrly"
                                    :picker-options="{start: '00:00', step: '00:30', end: '23:30' }">
                                </el-time-select>
                                <span class="form-label-min-hours">Minimum</span>
                                <el-input :disabled=true class="min-hours-field" v-model="form.min_hours.saturday"></el-input>
                            </el-form-item>
                            <el-form-item label="Sunday">
                                <span class="form-label-times">Open</span>
                                <el-time-select
                                    v-model="form.opening_times.sunday.open"
                                    @change="calcMinimum('sunday')"
                                    placeholder="Open">
                                </el-time-select>
                                <span class="form-label-min-hours">Close</span>
                                <el-time-select
                                    arrow-control
                                    v-model="form.opening_times.sunday.close"
                                    @change="calcMinimum('sunday')"
                                    placeholder="Close"
                                    class="ml-5-howrly"
                                    :picker-options="{start: '00:00', step: '00:30', end: '23:30' }">
                                </el-time-select>
                                <span class="form-label-min-hours">Minimum</span>
                                <el-input :disabled=true class="min-hours-field" v-model="form.min_hours.sunday"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import vue from 'vue'
import { getHeadersWithAccessToken } from '../../functions.js'

var checkNumber = (rule, value, callback) => {
    if (isNaN(value) === true) { // returns true if the variable does NOT contain a valid number
        callback(new Error('Please input digits'))
    } else {
        callback()
    }
}
// eslint-disable-next-line
var checkString = (rule, value, callback) => {
    if (isNaN(value) === false) { // returns true if the variable does NOT contain a valid number
        callback(new Error('Please input digits'))
    } else {
        callback()
    }
}

export default {
    data () {
        return {
            form: {},
            loaded: false,
            sundayOpeningOptions: [],
            parameterOptions: [],
            parameters: [],
            numParams: 1,
            parameterValues: [],
            hardcodedFields: ['store_square_meters', 'min_employees'],
            rules: {
                'store_square_meters': [
                    { required: true, message: 'Please input the store surface', trigger: 'blur' },
                    { validator: checkNumber, message: 'Value should be a number', trigger: 'blur' }
                ],
                'min_employees': [
                    { required: true, message: 'Please input minimum employees', trigger: 'blur' },
                    { validator: checkNumber, message: 'Value should be a number', trigger: 'blur' }
                ],
                'opening_times.monday.open': [
                    { required: true, message: 'Please input a time', trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        parametersLeft () { // Function to check if there are options available for parameters to be added, only return false when not already parameters selected (parameters.length === 0)
            let cnt = 0
            for (let option of this.parameterOptions) {
                if (Object.keys(this.form).includes(option.name) === false && Object.keys(this.form.dataload).includes(option.name) === false) {
                    cnt += 1
                }
            }
            return cnt - this.parameters.length
        }
    },
    methods: {
        deleteExistingProperty (prop) {
            const form = { ...this.form }
            delete form.dataload[prop]
            this.form = form
        },
        deleteNewProperty (prop) {
            let idx = this.parameters.indexOf(prop)
            this.parameters.splice(idx, 1)
            this.numParams -= 1
        },
        calcMinimum (day) {
            if (day !== 'all') { // A opening or closing time has changed
                let open = this.form.opening_times[day].open.split(':')
                let openMinutes = (+open[0]) * 60 + (+open[1])
                let close = this.form.opening_times[day].close.split(':')
                let closeMinutes = (+close[0]) * 60 + (+close[1])
                let hoursOpen = (closeMinutes - openMinutes) / 60
                if (hoursOpen < 0) {
                    hoursOpen = 0
                }
                if (this.form.min_employees !== null) {
                    vue.set(this.form.min_hours, day, (hoursOpen * this.form.min_employees).toFixed(1))
                } else {
                    vue.set(this.form.min_hours, day, hoursOpen.toFixed(1))
                }
            } else { // Min employees has changed
                let days = Object.keys(this.form.min_hours)
                for (let day of days) {
                    let open = this.form.opening_times[day].open.split(':')
                    let openMinutes = (+open[0]) * 60 + (+open[1])
                    let close = this.form.opening_times[day].close.split(':')
                    let closeMinutes = (+close[0]) * 60 + (+close[1])
                    let hoursOpen = (closeMinutes - openMinutes) / 60
                    if (hoursOpen < 0) {
                        hoursOpen = 0
                    }
                    if (this.form.min_employees !== null) {
                        vue.set(this.form.min_hours, day, (hoursOpen * this.form.min_employees).toFixed(1))
                    } else {
                        vue.set(this.form.min_hours, day, hoursOpen.toFixed(1))
                    }
                }
            }
        },
        submit () {
            for (let idx in this.parameters) {
                // Add the chosen parameters in the form
                if (isNaN(this.parameterValues[idx]) === false && this.parameterValues[idx] !== true && this.parameterValues[idx] !== false) {
                    this.parameterValues[idx] = parseFloat(this.parameterValues[idx])
                }
                if (this.parameterValues[idx] !== null && this.parameterValues[idx] !== undefined) {
                    vue.set(this.form.dataload, this.parameters[idx], this.parameterValues[idx])
                }
            }

            this.$refs['formSettings'].validate((valid) => {
                if (valid) {
                    let returnData = JSON.parse(JSON.stringify(this.form))
                    for (let day in returnData.opening_times) {
                        vue.set(returnData.opening_times[day], 'open', this.getMinutes(returnData.opening_times[day].open))
                        vue.set(returnData.opening_times[day], 'close', this.getMinutes(returnData.opening_times[day].close))
                    }

                    for (let idx in this.parameters) {
                        returnData['dataload'][this.parameters[idx]] = this.parameterValues[idx]
                    }

                    axios.put(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/store?store_id=' + this.$route.query.store_id, returnData, { 'headers': getHeadersWithAccessToken() })
                        .then(response => {
                            this.$router.push({ 'name': 'settings-stores', 'params': { 'update': true, 'delete': false, 'added': false, 'store_id': this.$route.query.store_id } })
                        })
                        .catch(error => {
                            console.log(error)
                        })
                } else {
                    console.log('Not valid')
                }
            })
        },
        deleteStore () {
            axios.delete(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/store?store_id=' + this.$route.query.store_id, { 'headers': getHeadersWithAccessToken() })
                .then(response => {
                    this.$router.push({ 'name': 'settings-stores', 'params': { 'update': false, 'delete': true, 'added': false, 'store_id': this.$route.query.store_id } })
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getTime (input) {
            let hours = Math.floor(input / 60).toString()
            let minutes = (input % 60).toString()

            if (minutes.length === 1) {
                minutes += '0'
            }
            return hours + ':' + minutes
        },
        getMinutes (input) {
            let hours = input.split(':')[0]
            let minutes = input.split(':')[1]
            return parseInt(hours) * 60 + parseInt(minutes)
        }
    },
    created () {
        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/store?store_id=' + this.$route.query.store_id, { 'headers': getHeadersWithAccessToken() })
            .then(response => {
                this.form = response.data.data
                if (this.form['dataload'] === null) {
                    this.form['dataload'] = {}
                }
                for (let day in this.form.opening_times) {
                    vue.set(this.form.opening_times[day], 'open', this.getTime(this.form.opening_times[day].open))
                    vue.set(this.form.opening_times[day], 'close', this.getTime(this.form.opening_times[day].close))
                }
                axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/parameters', { 'headers': getHeadersWithAccessToken() })
                    .then(response => {
                        this.parameterOptions = response.data.data
                        console.log(response.data.data)
                        for (let param of response.data.data) {
                            if (param.type === 'float' || param.type === 'int') {
                                this.rules['dataload.' + param.name] = [
                                    { required: true, message: 'This value is mandatory', trigger: 'blur' },
                                    { validator: checkNumber, message: 'Value should be a number', trigger: 'blur' }
                                ]
                            } else if (param.type === 'text') {
                                this.rules['dataload.' + param.name] = [
                                    { required: true, message: 'This value is mandatory', trigger: 'blur' },
                                    { validator: checkString, message: 'Value should be a number', trigger: 'blur' }
                                ]
                            }
                        }
                        this.loaded = true
                    })
                    .catch(error => {
                        console.log(error)
                    })
            })
            .catch(error => {
                console.log(error)
            })

        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/sundays', { 'headers': getHeadersWithAccessToken() })
            .then(response => {
                this.sundayOpeningOptions = response.data.data
            })
            .catch(error => {
                console.log(error)
            })
    }
}
</script>

<style lang="scss">
.component-settings-store-detail {
    p {
        margin-bottom: 0px;
    }
    .el-card__body {
        padding-bottom: 0px !important;
    }
    .el-input__inner {
        max-width: 250px !important;
    }
    .min-hours-field {
        display: inline-block;
        width: 60px;
        margin-left: 5px;
        .el-input__inner {
            text-align: center;
        }
    }
    .el-date-editor {
        max-width: 100px;
    }
    .el-input__inner {
        text-align: left;
    }

    .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    }
    label {
        margin-bottom: 0rem;
    }
    .form-label-times {
        color: #606266;
        margin-left: 20px;
        margin-right: 5px;
    }
    .form-label-min-hours {
        color: #606266;
        margin: 0px 5px;
    }

}
</style>
